import { registerPlugin } from "@capacitor/core";

/** Mirrors `PushDiagnostics.Stage` in ios/App/Shared/PushDiagnostics.swift. */
export type PushDiagnosticStage =
  | "serviceExtension"
  | "serviceExtensionExpired"
  | "willPresent"
  | "didReceive"
  | "legacyAppDelegate"
  | "tokenRegistered"
  | "tokenFailed"
  | "webview";

export interface PushDiagnosticEntry {
  stage: PushDiagnosticStage;
  /** ISO 8601 with milliseconds, from the process that recorded the entry. */
  at: string;
  /** Bundle id, so app entries can be told from extension entries. */
  process: string;
  /** Absent on the token stages, which belong to no single notification. */
  notificationId?: string;
  [field: string]: unknown;
}

interface PushDiagnosticsPlugin {
  /** Returns the trail as raw JSON lines and clears it. */
  drain(): Promise<{ entries: string[] }>;
  record(options: { notificationId: string; note?: string }): Promise<void>;
}

const PushDiagnostics = registerPlugin<PushDiagnosticsPlugin>("PushDiagnostics");

export default PushDiagnostics;
